import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { DatasearchService } from '../../_services/datasearch.service';

@Component({
  selector: 'app-event-details',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgFor, NgIf, RouterLink, DatePipe],
  templateUrl: './event-details.component.html',
  styleUrl: './event-details.component.scss'
})
export class EventDetailsComponent {
  transparent = false;
  event_details: any = {};
  eventImageBaseUrl = '';
  logoBaseUrl = '';
  slug: any;
  currentUrl: string;
  constructor(private datasearch_service: DatasearchService, private route: ActivatedRoute,) {
    this.eventImageBaseUrl = this.datasearch_service.ApiUrl + '/uploads/events/';
    this.logoBaseUrl = this.datasearch_service.ApiUrl + '/uploads/events/';
    this.currentUrl = window.location.href; // Get the current URL
  }

  ngOnInit() {
    const route: any = this.route?.snapshot?.params
    this.slug = route?.id
    if (this.slug) {
      this.getEvent();
    }
    // this.getEvent();
  }
  getEvent() {
    this.datasearch_service.getEventDetails(this.slug).subscribe((res) => {
      this.event_details = res.data;
    },
      (error) => {
      });

  }
  openLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }
  // getEvent(){
  //   this.event_details = {      
  //     event_name: "Standards and Scientific Advice on Food and Nutrition",
  //     description: "<p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.<br>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page. When looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. <br>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>",
  //     event_address: "2E/8, Third Floor, Jhandewalan Extension, Jhandewalan, New Delhi, Delhi 110055, India",
  //     event_date: "2024-01-22",
  //     date: "22",
  //     month: "Jan",
  //     year: "2024",
  //     event_end_time: "13:00",
  //     event_images: [
  //       'event_img_1.png', 'event_img_2.png', 'event_img_3.png', 'event_img_4.png', 'event_img_5.png', 'event_img_6.png'
  //     ],
  //     event_logo: "1.png",      
  //     event_poster: "1.png",
  //     event_start_time: "06:00",
  //     key_point_description: "<p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. It is a long established.</p>",
  //     key_points: [
  //       "When looking at its layout. It is a long established fact that a reader will be distracted",
  //       "When looking at its layout. It is a long established fact.",
  //       "Validity of MRL's (Expiry)",
  //       "MRL data displayed with reference citation"
  //     ],      
  //     speakers: [
  //       {speaker_name: 'Dr. Brie Larson', description: 'PHD Student', profile_image: 'User_1.png'},
  //       {speaker_name: 'Dr. Margt Robbie', description: 'PHD Student', profile_image: 'User_2.png'},
  //       {speaker_name: 'Dr. Gerard Butler', description: 'PHD Student', profile_image: 'User_3.png'}
  //     ]      
  //   }
  // }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }

  getEventImageUrl(poster: string): string {
    if (!poster) return '';
    const strFile = poster.toString();
    if (strFile.startsWith('http')) return strFile;

    let cleanPath = strFile.replace(/^\//, '');
    if (!cleanPath.includes('uploads/')) {
      cleanPath = 'uploads/events/' + cleanPath;
    }
    const baseUrl = this.datasearch_service.ApiUrl.replace(/\/$/, '');
    return `${baseUrl}/${cleanPath}`;
  }

  getLogoImageUrl(logo: string): string {
    if (!logo) return '';
    const strFile = logo.toString();
    if (strFile.startsWith('http')) return strFile;

    let cleanPath = strFile.replace(/^\//, '');
    if (!cleanPath.includes('uploads/')) {
      cleanPath = 'uploads/events/' + cleanPath;
    }
    const baseUrl = this.datasearch_service.ApiUrl.replace(/\/$/, '');
    return `${baseUrl}/${cleanPath}`;
  }
}
